<template>
  <section id="about_us_top" class="section_padding">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="about_us_left">
            <!-- <h5>{{ about_us }}</h5> -->
            <h4>{{ title }}</h4>
            <p>{{ aboutInfo1 }}</p>
            <p>{{ aboutInfo2 }}</p>
            <p>{{ aboutInfo3 }}</p>
            <p>{{ aboutInfo4 }}</p>
            <!-- <p>{{ aboutInfo4 }}</p> -->
            <!-- <router-link to="/tour-search" class="btn btn_theme btn_md">{{ findTour }}</router-link> -->
          </div>
        </div>
        <div class="col-lg-6">
          <div class="about_us_right">
            <img src="../../assets/img/common/abour_right.png" alt="img" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "AboutInfo",
  data() {
    return {
      about_us: "About us",
      title: "JAS Global Travel & Tourism LLC",
      aboutInfo1: `Dubai-based travel and tourism company committed to delivering seamless, reliable, and premium travel experiences across the UAE and beyond. With a strong understanding of global travel needs and regional expertise, we specialize in customized travel solutions for both leisure and corporate clients.`,
      aboutInfo2: `Our core services include travel and tourism management, holiday packages, hotel reservations, visa assistance, airport transfers, and rent-a-car services. Whether you are planning a family vacation, a business trip, or a luxury travel experience, JAS Global ensures comfort, efficiency, and value at every step.`,
      aboutInfo3: `In addition to travel services, we offer professional car rental solutions with well-maintained vehicles and experienced chauffeurs, providing safe and comfortable transportation across Dubai, the UAE, and selected international destinations. `,
      aboutInfo4: `At JAS Global Travel & Tourism LLC, customer satisfaction is at the heart of everything we do. Our mission is to create memorable journeys by combining trusted service, competitive pricing, and personalized support. We aim to be a one-stop solution for all travel and mobility needs, connecting people to destinations with confidence and care.`
      // findTour: 'Find tours'
    };
  },
};
</script>
